// extracted by mini-css-extract-plugin
export var resourceCardButton = "resourceFeaturedCard-module--resourceCardButton--595d0";
export var resourceFeaturedCard = "resourceFeaturedCard-module--resourceFeaturedCard--47dbe";
export var resourceFeaturedCardType = "resourceFeaturedCard-module--resourceFeaturedCardType--480f3";